(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('HubspotLeadDetailController', HubspotLeadDetailController);

    HubspotLeadDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'HubspotLead', 'User'];

    function HubspotLeadDetailController($scope, $rootScope, $stateParams, entity, HubspotLead, User) {
        var vm = this;

        vm.hubspotLead = entity;

        var unsubscribe = $rootScope.$on('valueconnectApp:hubspotLeadUpdate', function(event, result) {
            vm.hubspotLead = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
